// App.js
import React, { useState } from 'react';
import { Music2 } from 'lucide-react';
import AudioGenerator from './components/AudioGenerator';
import { AudioStreamer } from './components/AudioStreamer';

export function App() {
  const [showGenerator, setShowGenerator] = useState(true);
  const [processId, setProcessId] = useState(null);

  const handleGenerated = (result) => {
    console.log('Generation result:', result);
    if (result.process_id) {
      setProcessId(result.process_id);
      setShowGenerator(false);
    }
  };

  const handleRegenerateClick = () => {
    setShowGenerator(true);
    setProcessId(null); // Clear the previous process
  };

  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto py-8 px-4">
        <div className="text-center mb-8">
          <div className="inline-flex p-3 bg-purple-500/20 rounded-xl mb-4">
            <Music2 className="w-8 h-8 text-purple-400" />
          </div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-purple-400 to-pink-500 bg-clip-text text-transparent mb-2">
            Mindful AI Wellness Guide
          </h1>
          <p className="text-gray-400">Create your personalized wellness audio experience</p>
        </div>

        <div className="space-y-8">
          {showGenerator ? (
            <AudioGenerator onGenerated={handleGenerated} />
          ) : (
            <AudioStreamer 
              fileId={processId} // Changed from processId to fileId to match the component prop
              onRegenerateClick={handleRegenerateClick} 
            />
          )}
        </div>
      </div>
    </div>
  );
}